import * as React from "react";

import type { FormItemProps } from "@ant-design/compatible/es/form";
import { FormField, FormItem, FormLabel } from "@impero-com/ui";

import { ErrorValue } from "org/control/list/controls/common/errors";

/**
 The Base FormDisplay Props, a look alike form component without any interaction.
 * @field label the label, "title" of this field
 */
interface BaseFormDisplayProps {
    label?: string;
    helpText?: string;
    className?: string;
    children: React.ReactNode;
    error?: string;
}

class BaseFormDisplay extends React.PureComponent<BaseFormDisplayProps> {
    render() {
        const { children, label, helpText, className, error } = this.props;

        return (
            <FormField className={className} error={error}>
                {(label || helpText) && (
                    <FormLabel helpText={helpText}>{label}</FormLabel>
                )}
                {children}
            </FormField>
        );
    }
}

interface BaseFormItemProps extends FormItemProps {
    error?: ErrorValue;
}

class BaseFormItem extends React.PureComponent<BaseFormItemProps> {
    render() {
        const { children, className, error } = this.props;

        return (
            <FormItem
                hasFeedback={this.props.hasFeedback}
                customError={error}
                className={className}
            >
                {children}
            </FormItem>
        );
    }
}

export { type BaseFormDisplayProps, BaseFormDisplay, BaseFormItem };
